// ✅ Fuente única de verdad para los roles y sus permisos.
// Antes estos arrays vivían duplicados (y podían desincronizarse) en
// Home.jsx, GetForms.jsx y Stats.jsx.

export const ROLES = {
  administrador: "administrador",
  administradorT1: "administrador-t1",
  administradorT2: "administrador-t2",
  supervisor: "supervisor",
  custom: "custom",
  operadorCustom: "operador custom",
  operador: "operador",
};

export const normalizeRole = (role) => (role || "").toString().trim().toLowerCase();

// Roles "custom": pueden reasignar firma de operador al crear/editar formularios.
export const CUSTOM_ROLES = [ROLES.custom, ROLES.operadorCustom];

// Quién puede ver formularios / indicadores.
export const VIEW_FORMS_ROLES = [
  ROLES.administrador,
  ROLES.administradorT1,
  ROLES.administradorT2,
  ROLES.supervisor,
  ...CUSTOM_ROLES,
];

// Quién puede eliminar formularios.
export const DELETE_FORMS_ROLES = [ROLES.administrador, ...CUSTOM_ROLES];

// Quién puede editar la firma de un formulario ya creado.
export const EDIT_FIRMA_ROLES = [...CUSTOM_ROLES];

export const isAdminRole = (role) => normalizeRole(role) === ROLES.administrador;
export const isCustomRole = (role) => CUSTOM_ROLES.includes(normalizeRole(role));
export const canViewForms = (role) => VIEW_FORMS_ROLES.includes(normalizeRole(role));
export const canDeleteForms = (role) => DELETE_FORMS_ROLES.includes(normalizeRole(role));
export const canEditFirma = (role) => EDIT_FIRMA_ROLES.includes(normalizeRole(role));

// Solo "operador custom" puede editar la fecha manualmente al crear un formulario.
export const canEditFormDate = (role) => normalizeRole(role) === ROLES.operadorCustom;
